var _circle, _circle2, _circle3, _circle4, _circle5, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBoxGraySm = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 152,
  height: 131,
  fill: "none",
  viewBox: "0 0 152 131",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 76,
  cy: 58,
  r: 52,
  fill: "var(--utility-gray-200, black)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 25,
  r: 5,
  fill: "var(--utility-gray-100, black)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 109,
  r: 7,
  fill: "var(--utility-gray-100, black)"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 41,
  r: 7,
  fill: "var(--utility-gray-100, black)"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 14,
  r: 4,
  fill: "var(--utility-gray-100, black)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_dd_1182_1936)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-gray-200, black)",
  d: "m76 36.063 4.536-1.9-4.535 1.932V90.19l41.795-17.515V18.557l.204-.086-.204-.09v-.091l-.104.045L76.33 0 34 18.031l.2.087-.2 53.899 42 18.14z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-gray-100, black)",
  d: "M76 36.063v54.095L34 72.017l.2-53.9zM76 36.095V90.19l41.796-17.515V18.29z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-gray-100, black)",
  d: "m76 36.063 42-17.592L76.33 0 34 18.031z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-gray-200, black)",
  d: "M49.832 11.287 91.672 29.5l.38 13.27 11.707-4.83-.354-13.354L60.327 6.817z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_b_1182_1936)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-gray-400, black)",
  d: "M52 92c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--fg-white)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m72 96 4-4m0 0 4 4m-4-4v9m8-4.257A5.5 5.5 0 0 0 80.5 87a.62.62 0 0 1-.534-.302 7.5 7.5 0 1 0-11.78 9.096"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoxGraySm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BoxGraySm.2d2563a4ab7a0cf854959175eb42e825.svg";